import { SeeMoreCard as BaseSeeMoreCard } from "../../../common/SeeMoreCard";
import { borderCardSize } from "../social-post/SocialPost";

import { type IUsePrefetchSocialPostsParams, usePrefetchSocialPosts } from "./usePrefetchSocialPosts";

interface ISeeMoreCardProps extends IUsePrefetchSocialPostsParams {
    onClick: () => void;
}

export const SeeMoreCard = ({ domain, socialMediaChannel, onClick }: ISeeMoreCardProps) => {
    const prefetch = usePrefetchSocialPosts({ domain, socialMediaChannel });

    const handleClick = () => {
        prefetch();
        onClick();
    };

    return (
        <BaseSeeMoreCard
            width={borderCardSize.width}
            height={borderCardSize.height}
            onClick={handleClick}
            dataAutomation="social-post-see-more-card"
        />
    );
};
